<div class="sticky-div">
<app-organizations-filter></app-organizations-filter>
</div>
<div class="content">
	<table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

		<ng-container matColumnDef="id">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.id}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.name}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="enabled">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Enabled</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.enabled}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="trial_account">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Trial</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.trial_account}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="days_from_appointment">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Appt Days</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.days_from_appointment}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="time_zone">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Time Zone</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.time_zone}}</div>
			</td>
		</ng-container>


		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goto(row)" >
		</tr>

	</table>

</div>
